import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, mapIdsToLabels } from './chartUtils';

const OrganizationChatterTotalEarningsByTimeChart = ({ data, chatterLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.chatterId], chatterLabelMap)[0],
        data: item.totalEarnings || [],
      })),
    }),
    [data, chatterLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Total Earnings Over Time"
      subtitle="Earnings trend for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more chatters to load earnings over time."
    />
  );
};

export default OrganizationChatterTotalEarningsByTimeChart;
